interface FormData {
  submissionId?: string;
  timestamp?: string;
  errorType?: string;
  formType?: string;
  [key: string]: string | number | boolean | undefined;
}

interface DataLayerObject {
  event: string;
  formName?: string;
  formData?: FormData;
  pagePath?: string;
  [key: string]: string | FormData | undefined;
}

declare global {
  interface Window {
    dataLayer: DataLayerObject[];
  }
}

export const initializeGTM = (gtmId: string): void => {
  if (typeof window !== 'undefined' && gtmId) {
    window.dataLayer = window.dataLayer || [];

    const script = document.createElement('script');
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;
    document.head.appendChild(script);

    const noscript = document.createElement('noscript');
    noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    document.body.appendChild(noscript);
  }
};

export const pushToDataLayer = (data: DataLayerObject): void => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push(data);
  }
};

export const GTMEvents = {
  formSubmit: (formName: string, additionalData?: FormData) => {
    pushToDataLayer({
      event: 'ibs_form_submit',
      formName,
      ...additionalData,
    });
  },
};
